import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ThirdPartyGamesComponent } from './thirdpartygames/thirdpartygames';
import { ThirdPartyHistoryComponent } from './third-party-history/third-party-history';

@NgModule({
  declarations: [
    ThirdPartyGamesComponent,
    ThirdPartyHistoryComponent    
  ],
  imports: [
    IonicPageModule.forChild(ThirdPartyGamesModule),
  ],
  exports: [
    ThirdPartyGamesComponent,
    ThirdPartyHistoryComponent
  ]
})
export class ThirdPartyGamesModule {}



// WEBPACK FOOTER //
// ./src/app/thirdpartygames/thirdpartygames.module.ts